import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correctionUploadAnswerCardModal.title',
    defaultMessage: 'ADD NEW SKILL',
  },
  singularTitle: {
    id: 'simulated.correctionUploadAnswerCardModal.singularTitle',
    defaultMessage: 'ANSWER CARD UPLOAD',
  },
  pluralTitle: {
    id: 'simulated.correctionUploadAnswerCardModal.pluralTitle',
    defaultMessage: 'ANSWER CARDS UPLOAD',
  },
  cancel: {
    id: 'simulated.correctionUploadAnswerCardModal.cancel',
    defaultMessage: 'Cancel',
  },
  continue: {
    id: 'simulated.correctionUploadAnswerCardModal.continue',
    defaultMessage: 'Continue',
  },
  finish: {
    id: 'simulated.correctionUploadAnswerCardModal.finish',
    defaultMessage: 'Finish',
  },
  loading: {
    id: 'simulated.correctionUploadAnswerCardModal.loading',
    defaultMessage:
      '<div style="display:flex">Please wait... <span class="loading show simple"></span></div>',
  },
  uploadInfo: {
    id: 'simulated.correctionUploadAnswerCardModal.uploadInfo',
    defaultMessage: 'Drag and drop your file',
  },
  uploadInfoClick: {
    id: 'simulated.correctionUploadAnswerCardModal.uploadInfoClick',
    defaultMessage: 'or click here',
  },
  dragDrop: {
    id: 'classesStudents.addClassModal.dragDrop',
    defaultMessage: 'Drag and drop file to upload',
  },
  clickHere: {
    id: 'classesStudents.addClassModal.clickHere',
    defaultMessage: 'or click here',
  },
  alreadyAdded: {
    id: 'classesStudents.addClassModal.alreadyAdded',
    defaultMessage: 'Response cards {files} have already been loaded:',
  },
  errorAlreadyExists: {
    id: 'simulated.correctionUploadAnswerCardModal.errorAlreadyExists',
    defaultMessage: 'There is already a correction for this student.',
  },
  errorAnswersheetNotMatchEvaluation: {
    id: 'simulated.correctionUploadAnswerCardModal.errorAnswersheetNotMatchEvaluation',
    defaultMessage: 'AnswerSheet dont match with evaluation.',
  },
  errorStudentNotFound: {
    id: 'simulated.correctionUploadAnswerCardModal.errorStudentNotFound',
    defaultMessage: 'Student not found',
  },
  errorNoPermission: {
    id: 'simulated.correctionUploadAnswerCardModal.errorNoPermission',
    defaultMessage: 'This student does not have permission for that school.',
  },
  errorGeneric: {
    id: 'simulated.correctionUploadAnswerCardModal.errorGeneric',
    defaultMessage: 'Error loading answer card',
  },
  uploading: {
    id: 'simulated.correctionUploadAnswerCardModal.uploading',
    defaultMessage: 'Sending...',
  },
  uploadedSuccess: {
    id: 'simulated.correctionUploadAnswerCardModal.uploadedSuccess',
    defaultMessage: 'Successfully uploaded',
  },
  overwriteTitle: {
    id: 'simulated.correctionUploadAnswerCardModal.overwriteTitle',
    defaultMessage: 'Overwrite results?',
  },
  overwriteMessage: {
    id: 'simulated.correctionUploadAnswerCardModal.overwriteMessage',
    defaultMessage:
      'The student "{studentName}" already has an answer sheet loaded. Are you sure you want to overwrite the answers with this new card? This operation is irreversible.',
  },
  overwriteConfirm: {
    id: 'simulated.correctionUploadAnswerCardModal.overwriteConfirm',
    defaultMessage: 'Yes, overwrite',
  },
});
